
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {ClientReportsSendResponse} from './ClientReportsSendResponse';
import {ClientReportType} from '../core/ClientReportType';
import {FieldModelClientReportType} from '../core/ClientReportType';
import {ClientReportSendType} from '../core/ClientReportSendType';
import {FieldModelClientReportSendType} from '../core/ClientReportSendType';

/**
 * ClientReportsSendRequest struct
 */
class ClientReportsSendRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!ClientReportType=} clientReportType
   * @param {!ClientReportSendType=} clientReportSendType
   * @param {!Date=} rolloverTimestamp
   * @param {number=} login
   * @param {!boolean=} force
   * @constructor
   */
  constructor (parent = new Request(), clientReportType = new ClientReportType(), clientReportSendType = new ClientReportSendType(), rolloverTimestamp = new Date(0), login = null, force = false) {
    super()
    super.copy(parent)
    this.ClientReportType = clientReportType
    this.ClientReportSendType = clientReportSendType
    this.RolloverTimestamp = rolloverTimestamp
    this.Login = login
    this.Force = force
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ClientReportsSendRequest}
   * @param {!ClientReportsSendRequest} other Other struct
   * @returns {!ClientReportsSendRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.ClientReportType != null) {
      this.ClientReportType = ClientReportType.fromObject(other.ClientReportType)
    } else {
      this.ClientReportType = null
    }
    if (other.ClientReportSendType != null) {
      this.ClientReportSendType = ClientReportSendType.fromObject(other.ClientReportSendType)
    } else {
      this.ClientReportSendType = null
    }
    if (other.RolloverTimestamp != null) {
      if (other.RolloverTimestamp instanceof Date) {
        this.RolloverTimestamp = new Date(other.RolloverTimestamp.getTime())
      } else {
        this.RolloverTimestamp = new Date(Math.round(other.RolloverTimestamp / 1000000))
      }
    } else {
      this.RolloverTimestamp = null
    }
    if (other.Login != null) {
      this.Login = UInt64.fromNumber(other.Login)
    } else {
      this.Login = null
    }
    if (other.Force != null) {
      this.Force = other.Force
    } else {
      this.Force = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ClientReportsSendRequest}
   * @returns {!ClientReportsSendRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ClientReportsSendRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ClientReportsSendRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ClientReportsSendRequest}
   * @param {!ClientReportsSendRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientReportsSendRequest)) {
      throw new TypeError('Instance of ClientReportsSendRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ClientReportsSendRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      ClientReportType: ((this.ClientReportType != null) ? this.ClientReportType : null),
      ClientReportSendType: ((this.ClientReportSendType != null) ? this.ClientReportSendType : null),
      RolloverTimestamp: ((this.RolloverTimestamp != null) ? (this.RolloverTimestamp.getTime() * 1000000) : null),
      Login: ((this.Login != null) ? this.Login.toNumber() : null),
      Force: ((this.Force != null) ? this.Force : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ClientReportsSendRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ClientReportsSendRequest} other Object value
   * @returns {!ClientReportsSendRequest} Created struct
   */
  static fromObject (other) {
    return new ClientReportsSendRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ClientReportsSendRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ClientReportsSendRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ClientReportsSendRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3018
  }
}

export { ClientReportsSendRequest };

/**
 * Fast Binary Encoding ClientReportsSendRequest field model
 */
class FieldModelClientReportsSendRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.ClientReportType = new FieldModelClientReportType(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ClientReportSendType = new FieldModelClientReportSendType(buffer, this.ClientReportType.fbeOffset + this.ClientReportType.fbeSize)
    this.RolloverTimestamp = new fbe.FieldModelTimestamp(buffer, this.ClientReportSendType.fbeOffset + this.ClientReportSendType.fbeSize)
    this.Login = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.RolloverTimestamp.fbeOffset + this.RolloverTimestamp.fbeSize), buffer, this.RolloverTimestamp.fbeOffset + this.RolloverTimestamp.fbeSize)
    this.Force = new fbe.FieldModelBool(buffer, this.Login.fbeOffset + this.Login.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.ClientReportType.fbeSize + this.ClientReportSendType.fbeSize + this.RolloverTimestamp.fbeSize + this.Login.fbeSize + this.Force.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.ClientReportType.fbeExtra + this.ClientReportSendType.fbeExtra + this.RolloverTimestamp.fbeExtra + this.Login.fbeExtra + this.Force.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelClientReportsSendRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3018
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelClientReportsSendRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelClientReportsSendRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClientReportType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientReportType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientReportType.fbeSize

    if ((fbeCurrentSize + this.ClientReportSendType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ClientReportSendType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientReportSendType.fbeSize

    if ((fbeCurrentSize + this.RolloverTimestamp.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RolloverTimestamp.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RolloverTimestamp.fbeSize

    if ((fbeCurrentSize + this.Login.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Login.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.Force.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Force.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Force.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelClientReportsSendRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelClientReportsSendRequest}
   * @param {!ClientReportsSendRequest} fbeValue Default value, defaults is new ClientReportsSendRequest()
   * @returns {!ClientReportsSendRequest} ClientReportsSendRequest value
   */
  get (fbeValue = new ClientReportsSendRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelClientReportsSendRequest}
   * @param {!ClientReportsSendRequest} fbeValue ClientReportsSendRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ClientReportType.fbeSize) <= fbeStructSize) {
      fbeValue.ClientReportType = this.ClientReportType.get()
    } else {
      fbeValue.ClientReportType = new ClientReportType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientReportType.fbeSize

    if ((fbeCurrentSize + this.ClientReportSendType.fbeSize) <= fbeStructSize) {
      fbeValue.ClientReportSendType = this.ClientReportSendType.get()
    } else {
      fbeValue.ClientReportSendType = new ClientReportSendType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ClientReportSendType.fbeSize

    if ((fbeCurrentSize + this.RolloverTimestamp.fbeSize) <= fbeStructSize) {
      fbeValue.RolloverTimestamp = this.RolloverTimestamp.get()
    } else {
      fbeValue.RolloverTimestamp = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RolloverTimestamp.fbeSize

    if ((fbeCurrentSize + this.Login.fbeSize) <= fbeStructSize) {
      fbeValue.Login = this.Login.get()
    } else {
      fbeValue.Login = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.Force.fbeSize) <= fbeStructSize) {
      fbeValue.Force = this.Force.get(false)
    } else {
      fbeValue.Force = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Force.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelClientReportsSendRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelClientReportsSendRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelClientReportsSendRequest}
   * @param {!ClientReportsSendRequest} fbeValue ClientReportsSendRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelClientReportsSendRequest}
   * @param {ClientReportsSendRequest} fbeValue ClientReportsSendRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.ClientReportType.set(fbeValue.ClientReportType)
    this.ClientReportSendType.set(fbeValue.ClientReportSendType)
    this.RolloverTimestamp.set(fbeValue.RolloverTimestamp)
    this.Login.set(fbeValue.Login)
    this.Force.set(fbeValue.Force)
  }
}

export { FieldModelClientReportsSendRequest };

/**
 * Fast Binary Encoding ClientReportsSendRequest model
 */
class ClientReportsSendRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelClientReportsSendRequest(this.buffer, 4)
  }

  /**
   * Get the ClientReportsSendRequest model
   * @this {!ClientReportsSendRequestModel}
   * @returns {!FieldModelClientReportsSendRequest} model ClientReportsSendRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ClientReportsSendRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ClientReportsSendRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ClientReportsSendRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ClientReportsSendRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelClientReportsSendRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ClientReportsSendRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ClientReportsSendRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ClientReportsSendRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ClientReportsSendRequestModel}
   * @param {!ClientReportsSendRequest} value ClientReportsSendRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ClientReportsSendRequestModel}
   * @param {!ClientReportsSendRequest} value ClientReportsSendRequest value, defaults is new ClientReportsSendRequest()
   * @return {!object} Deserialized ClientReportsSendRequest value and its size
   */
  deserialize (value = new ClientReportsSendRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ClientReportsSendRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ClientReportsSendRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ClientReportsSendRequestModel}
   * @param {!number} prev Previous ClientReportsSendRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ClientReportsSendRequestModel };
ClientReportsSendRequest.__has_response = true;
ClientReportsSendRequest.__response_class = ClientReportsSendResponse;
